import { Entry } from '../Entry'

export function Entry20251029() {
  return (
    <Entry title="2025 Oct 29 - v3.11.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/18116/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
